import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../configuracion/config.service';
import { RequestBaseService } from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class EncuestaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'encuesta'].join('/');
  }

  public consultarTodo(ordfr, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'consultar-todo', ordfr, conDatos].join('/') + label)
      .map(res => res.json());
  }

  public getRepository(): any {
    return this.http.get(`${this.ApiUrl}/repositorio`).map(res => res.json());
  }

  getEncuestasByUser(userId: any): any {
    return this.http.get(`${this.ApiUrl}/usuario/${userId}`).map(res => res.json());
  }

  public consultarPorOrganizacion(id_org, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'organizacion', id_org, conDatos].join('/') + label)
      .map(res => res.json());
  }

  move(id: any, orgId: any, proId: any): any {
    return this.http
      .put(`${this.ApiUrl}/${id}/mover`, {data: {org_id: orgId, pro_id: proId}})
      .map(res => res.json());

  }

  public consultarPorProyecto(id_pro, ordfr, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'proyecto', id_pro, ordfr, conDatos].join('/') + label)
      .map(res => res.json());
  }

  public consultarPorFechasYPro(fi, ff, id_pro, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'fechas-pro', fi, ff, id_pro, conDatos].join('/') + label)
      .map(res => res.json());
  }

  public consultarPorFechas(fi, ff, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'fechas', fi, ff, conDatos].join('/') + label)
      .map(res => res.json());
  }

  public consultarPorFechasYOrg(fi, ff, id_org, conDatos, label = '') {
    return this.http
      .get([this.ApiUrl, 'fechas-org', fi, ff, id_org, conDatos].join('/') + label)
      .map(res => res.json());
  }

  public createRepo(item: any): any {
    return this.http.post(`${this.ApiUrl}/crear-repo`, {data: {id: item.id, catId: item.categoria_id} }).map(res => res.json());
  }

  public getDatosEncuesta(id) {
    return this.http
      .get([this.ApiUrl, 'datos-encuesta', id].join('/'))
      .map(res => res.json());
  }

  public getExportarEncuesta(id, label = '') {
    return this.http
      .get(
        `${this.ApiUrl}/consulta/${id}/exportar${label}`,
        { responseType: ResponseContentType.Blob }
      );
  }

  exportarRespuestas(id: any, ids: any): Observable<any> {
    const url = `${this.ApiUrl}/${id}/exportar${ids != null ? `?ids=${JSON.stringify(ids)}` : ''}`;

    return this.http.get(url, { responseType: ResponseContentType.Blob });
  }

  public getGraficarEncuesta(label = '') {
    return this.http
      .get([this.ApiUrl, 'consulta', 'graficar'].join('/') + label)
      .map(res => res.json());
  }

  public consultarEncuestasPermitidasRagoMeses(agrupados) {
    return this.http
      .get([this.ApiUrl, 'proyectos', 'rago', 'permisos', agrupados].join('/'))
      .map(res => res.json());
  }

  public consultarEnvioDeEncuesta() {
    return this.http
      .get([this.ApiUrl, 'envio', 'encuestas'].join('/'))
      .map(res => res.json());
  }

  public consultaGraficarPrimeras5(idEncuesta, ids: Array<string>) {
    const idsParam = JSON.stringify(ids);

    return this.http
      .get(`${this.ApiUrl}/preguntas/pordefecto/${idEncuesta}?ids=${idsParam}`)
      .map(res => res.json());
  }

  public compararEncuestas(encuestas: any[]): Observable<any> {
    return this.http
      .post(`${this.ApiUrl}/comparar`, { data: encuestas })
      .map(res => res.json());
  }

  public exportarComparacionEncuestas(model: any): Observable<any> {
    return this.http.post(
      `${this.ApiUrl}/comparar/exportar`,
      { data: model },
      { responseType: ResponseContentType.Blob }
    );
  }

  public getEncuestaByIdentificador(identificador: string): Observable<any> {
    return this.http
      .get(`${this.ApiUrl}/identificador/${identificador}`)
      .map(res => res.json());
  }

  public suscribe(encuestaId: number, model: any) {
    return this.http
      .put(`${this.ApiUrl}/${encuestaId}/suscribir`, {data: model})
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/encuesta/encuesta.service.ts